import { render, staticRenderFns } from "./harmfulInformation.vue?vue&type=template&id=452393e2&scoped=true"
import script from "./harmfulInformation.vue?vue&type=script&lang=js"
export * from "./harmfulInformation.vue?vue&type=script&lang=js"
import style0 from "./harmfulInformation.vue?vue&type=style&index=0&id=452393e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452393e2",
  null
  
)

export default component.exports